
import { TinyTheme, } from 'src/course/domain/CourseEditModel';
import { Card, CardBody, CardHeader } from 'reactstrap';
import LnIcon from 'src/components/LnIcon';
import { Link } from 'react-router-dom';
import { urlService } from 'src/services/NavService';

export default function DirtyTheme(props: { courseId: string, theme: TinyTheme }) {

  return (
    <div className='mb-3'>
      <Card className={["border border-primary"].join(' ')}>
        <CardHeader className={" px-1 py-0"} >

          <div className={`w-100 d-flex my-2 py-1 ps-3 pe-0`} >
            <LnIcon name="book" className="me-2 mt-2 icon-small" />
            <div>{props.theme.Name}</div>
          </div>

        </CardHeader>
        <CardBody>
          <div className='ps-5'>
            {props.theme.Parts.filter(p => p.Dirty).map(p => <div key={p.Id} className='d-flex mb-2'>
              <LnIcon name="alert" className='icon-small mt-2 me-3' />
              <Link to={urlService.urlToPartInCourse( props.courseId, props.theme.Id, p.Id, "publish")}>
                {p.Name}
              </Link>
            </div>)}
          </div>
        </CardBody>
      </Card>



    </div>
  )
}
